'use client'

import type { StoreFrontDto } from '@b-stock/listing-api-client'

import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'

import SignInWarning from './SignInWarning'
import { useSellerProfileLivePreview } from './useSellerProfileLivePreview'

/** The sign-in wall inside the Live Preview pane: its About copy follows the admin form. */
export default function SignInWarningLivePreview({
  storefront,
  profile,
  serverURL,
  legacyCostcoStyleAboutEnabled,
}: {
  storefront: StoreFrontDto
  profile: CmsSellerProfile
  serverURL: string
  legacyCostcoStyleAboutEnabled?: boolean
}) {
  const data = useSellerProfileLivePreview(profile, serverURL)
  return (
    <SignInWarning
      storefront={storefront}
      cmsSellerProfile={data}
      legacyCostcoStyleAboutEnabled={legacyCostcoStyleAboutEnabled}
    />
  )
}
